
import { useModels } from "./models";

export const useActions = () => {
    const models = useModels();
    
    return [
        {model: models.cleaning},
        {model: models.storage}, 
        {model: models.review},
        {model: models.list, showAlways: true},
        {model: models.service},
        {model: models["part-replacement"], hide: true},
        {model: models["part-withdrawal"], hide: true},
        {model: models.serviceStart, hide: true},
        {model: models.serviceEnd, hide: true},
        {model: models.dimensioning},
        {model: models.dimensioningStart, hide: true},
        {model: models.dimensioningEnd, hide: true},
    ];
};

